








import { Component, Vue } from 'vue-property-decorator';
import MainMenuGrouping from '@/views/layout/navigation/grouping/main-menu-grouping.vue';

@Component({
  components: {
    MainMenuGrouping
  }
})
export default class SettingsMenu extends Vue {}
